import { useState } from 'react'
import { api } from '../../shared/api/http'

export function CameraProvisioningPermission({ userId }: { userId: string }) {
  const [enabled, setEnabled] = useState<boolean | null>(null), [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false), [error, setError] = useState('')
  const path = `/platform/administration/users/${userId}/camera-provisioning`
  async function load() {
    setOpen(true); setBusy(true); setError('')
    try { setEnabled((await api<{ enabled: boolean }>(path)).enabled) }
    catch { setError('Não foi possível consultar a permissão.') }
    finally { setBusy(false) }
  }
  async function save(value: boolean) {
    setBusy(true); setError('')
    try { await api(path, { method: 'PUT', body: JSON.stringify({ enabled: value }) }); setEnabled(value) }
    catch { setError('A permissão não foi alterada.') }
    finally { setBusy(false) }
  }
  return <div style={{ paddingTop: 12 }}>
    <button type="button" onClick={() => open ? setOpen(false) : void load()}>Permissão de câmeras e RTMP</button>
    {open && <><p>Permitir cadastrar câmeras, gerar links RTMP e escolher pacotes de IA somente nos clientes aos quais este usuário tem acesso.</p>
      {enabled !== null && <label><input type="checkbox" checked={enabled} disabled={busy} onChange={event => void save(event.target.checked)} /> Permitir cadastro e links RTMP</label>}
      {busy && <p role="status">Salvando ou consultando…</p>}{error && <p role="alert">{error}</p>}
    </>}
  </div>
}
